module.exports = __webpack_public_path__ + "static/00004.33913a0f.jpg";